<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{LabelConstant.addNewSession}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
    </div>
    <mat-dialog-content class="">
        <div class="main-form">
            <form [formGroup]="addSessionForm" (ngSubmit)="submitAddSesionForm()" novalidate>
                <div class="report_box  p-3 mb-3">
                    <div>
                        <div class="report_title">{{LabelConstant.extraSession}}</div>
                        <ul class="event_list">
                            <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" alt="">{{LabelConstant.anySession}}</li>
                        </ul>
                    </div>
                    <div>
                        <div class="reporter_profile">
                            <img [src]="customerData?.images" (error)="handleImageError()" alt="" />
                            <ul>
                                <li>{{LabelConstant.reporter}}</li>
                                <li>{{customerData.firstName}} {{customerData.lastName}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="mb-3">
                            <mat-label>{{LabelConstant.replyTo}} {{customerData.firstName}} {{customerData.lastName}}
                                <span>*</span></mat-label>
                            <mat-form-field class="w-100">
                                <textarea placeholder="Enter message" matInput formControlName="AdminReply"
                                    oninput="this.value = this.value.replace(/^\s+/g, '')" maxlength="250"></textarea>
                            </mat-form-field>
                            <mat-error *ngIf="submitted && addSessionFormControls['AdminReply'].errors?.['required']">
                                {{ErrorMessage.replyIsRequired}}
                            </mat-error>
                        </div>
                    </div>
                    <div class="dialogue-footer">
                        <button class="btn btn-primary" type="submit">
                            {{LabelConstant.add}}
                        </button>
                        <button class="btn btn-info" type="button" (click)="cancel()">
                           {{LabelConstant.cancel}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </mat-dialog-content>
</div>